// @ts-ignore - Vite-specific import.meta.glob feature
const logoModules = import.meta.glob<{ default: string }>("../logos/*.png", {
  eager: true,
});

const logoMap: Record<string, string> = {};
for (const [path, module] of Object.entries(logoModules)) {
  const filename = path.split("/").pop() || "";
  logoMap[filename] = (module as { default: string }).default;
}

export function getClientLogo(logoFile: string): string | null {
  return logoMap[logoFile] || null;
}

export function getAvailableLogos(): string[] {
  return Object.keys(logoMap);
}

export { logoMap };
